import { useOrgSyntheticDataToggle } from "./useOrgSyntheticDataToggle";

export type KpiDatasetKind = "production" | "synthetic";

/**
 * Active KPI lane for Account Health / Always On reads.
 * Matches org `use_synthetic_data` and Data Hub Synthetic toggle.
 */
export function useKpiDatasetKind(): KpiDatasetKind {
  const { useSyntheticData } = useOrgSyntheticDataToggle();
  return useSyntheticData ? "synthetic" : "production";
}

export default useKpiDatasetKind;
